import React from 'react'

import { Flag, Colored } from '../../..'
import { colors, Routes } from '../../../../constants'
import { StoreUtils } from '../../../../utils'
import { FlagWrapper, Percentage, ActionGroup, StyledLink } from './EstateList.styles'

const tableDisplay = ({ search, t }) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: 'code',
            label: t('Code'),
            props: null,
            transform: (code) => (
                <div style={{ color: colors.grey }}>{code}</div>
            ),
            width: '100px',
        },
        {
            onlyOnMobile: true,
            field: 'name',
            label: t('store'),
            props: null,
            transform: null,
            width: '250px',
        },
        {
            onlyOnMobile: true,
            field: 'devices_count',
            label: t('Devices'),
            props: { align: 'center' },
            width: '90px',
        },
        {
            onlyOnMobile: true,
            field: 'offline',
            label: 'Online',
            props: { align: 'center' },
            transform: (offline = 1) => (
                <Colored center color={StoreUtils.offlineColor(1 - offline)}>
                    {StoreUtils.calculateofflinePercentage(offline)}
                    <Percentage>&nbsp;%</Percentage>
                </Colored>
            ),
            width: '80px',
        },
        {
            onlyOnMobile: true,
            field: 'code',
            key: 'view',
            label: '',
            props: { align: 'right' },
            transform: (code) => <StyledLink to={`${Routes.buildRoute(Routes.ESTATE_STORE, { code, search })}`}>{t('View')}</StyledLink>,
            width: '40px',
        },
        {
            field: 'code',
            label: t('Code'),
            props: null,
            transform: null,
            width: '70px',
        },
        {
            field: 'country_code',
            label: t('Country'),
            props: { align: 'center' },
            transform: (v) => (
                <FlagWrapper>
                    <Flag code={v} />
                </FlagWrapper>
            ),
            width: '80px',
        },
        {
            field: 'name',
            label: t('store'),
            props: null,
            transform: null,
            width: '230px',
        },
        {
            field: 'devices_count',
            label: t('Devices'),
            props: { align: 'center' },
            width: '90px',
        },
        {
            field: 'offline',
            label: 'Online',
            props: { align: 'center' },
            transform: (offline = 1) => (
                <Colored center color={StoreUtils.offlineColor(1 - offline)}>
                    {StoreUtils.calculateofflinePercentage(offline)}
                    <Percentage>&nbsp;%</Percentage>
                </Colored>
            ),
            width: '80px',
        },
        {
            field: 'address',
            label: t('Address'),
            props: { paddingLeft: '10px' },
            transform: null,
            width: '550px',
        },
        {
            field: 'postcode',
            label: t('PostCode'),
            onlyOnLG: true,
            props: null,
            transform: null,
            width: '80px',
        },
        {
            field: 'code',
            key: 'view',
            label: '',
            props: { align: 'right' },
            transform: (code) => (
                <ActionGroup>
                    <StyledLink to={`${Routes.buildRoute(Routes.ESTATE_STORE, { code, search })}`}>{t('View')}</StyledLink>
                </ActionGroup>
            ),
            width: null,
        },
    ]

    return elements
}

export default tableDisplay
